import {
  NavigationMenuContent,
  NavigationMenuTrigger,
  navigationMenuTriggerStyle,
} from "@/components/ui/navigation-menu";
import { NavType } from "@/types";
import { LinkWithParams } from "../LinkWithParams";
import { NavLink } from "./NavLink";

export const NavSubLinks = ({ subMenu, href, label, Icon }: NavType) => {
  return (
    <>
      <NavigationMenuTrigger className={navigationMenuTriggerStyle()}>
        <LinkWithParams href={href} className="flex items-center gap-2">
          {Icon && <Icon size={16} className="text-muted-foreground" />} {label}
        </LinkWithParams>
      </NavigationMenuTrigger>
      <NavigationMenuContent>
        <div className="grid w-48">
          {subMenu?.map(({ key, ...rest }) => (
            <NavLink key={key} {...rest} />
          ))}
        </div>
      </NavigationMenuContent>
    </>
  );
};
